export function generateTokenId(): bigint {
  const randomNum = Math.floor(Math.random() * Number(10n ** 18n));
  return BigInt(randomNum);
}
